Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.GoogleMyBusinessContentFactory
  types:
    review: Monitoring.Models.SocialContents.GoogleMyBusinessReviewContent
    reply: Monitoring.Models.SocialContents.GoogleMyBusinessReplyContent


  create: (socialContent) ->
    type = @types[socialContent?.content?.item_type]
    if type
      new type(socialContent)

  canHandle: (socialContent) ->
    return socialContent.group_type == 'google-my-business' and socialContent.data and socialContent.sub_type
